export enum ActivityPage {
  Articles = 'articles',
  ReleaseNotes = 'releaseNotes',
  DateChangeRequests = 'dateChangeRequests',
  Tasks = 'tasks',
}
